module.exports = __webpack_public_path__ + "static/media/header-bg-image.35dd755f.png";